import React from "react";
import { withStyles } from "@material-ui/core/styles/index";
import CircularProgress from "@material-ui/core/CircularProgress";
import Backdrop from "@material-ui/core/Backdrop";
import PropTypes from "prop-types";

const styles = theme => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff"
  }
});

const Loader = props => {
  const { classes, loading } = props;
  return (
    <div>
      {loading ? (
        <Backdrop className={props.classes.backdrop} open={true}>
          <CircularProgress color="inherit" />
        </Backdrop>
      ) : (
        props.children
      )}
    </div>
  );
};

Loader.propTypes = {
  classes: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired
};

export default withStyles(styles)(Loader);
